var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 0H2.72728C1.22104 0 0 1.22104 0 2.72728V17.2728C0 18.7789 1.22104 20 2.72728 20H17.2728C18.7789 20 20 18.7789 20 17.2728V2.72728C20 1.22104 18.7789 0 17.2728 0Z",
    fill: "#1185FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22349 5.36832C7.75212 6.50878 9.39631 8.82117 9.99998 10.0621C10.6037 8.82126 12.2479 6.50876 13.7766 5.36832C14.8796 4.54541 16.6666 3.90868 16.6666 5.93477C16.6666 6.33941 16.4332 9.33392 16.2963 9.82009C15.8203 11.5103 14.0861 11.9413 12.5434 11.6804C15.24 12.1365 15.9259 13.6473 14.4445 15.1579C11.631 18.0271 10.4006 14.4381 10.0852 13.5184C10.0274 13.3498 10.0004 13.271 9.99998 13.338C9.99956 13.271 9.97256 13.3498 9.91473 13.5184C9.59948 14.4381 8.36915 18.0272 5.55546 15.1579C4.074 13.6473 4.75995 12.1364 7.45653 11.6804C5.91383 11.9413 4.17954 11.5103 3.70368 9.82009C3.56675 9.33384 3.33331 6.33936 3.33331 5.93477C3.33331 3.90868 5.12055 4.54541 6.22349 5.36832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSky);
export default __webpack_public_path__ + "static/media/blueSky.9e0c4fd554b93b5d09c88d887b598fa7.svg";
export { ForwardRef as ReactComponent };